export default "__VITE_ASSET__Dh14p$Q2__"